import React, { useEffect } from 'react'
import PracticeLayout from './PracticeLayout';
import { Box } from '@chakra-ui/react';
import Assistant from '../../../components/molecules/ai-tutor/Assistant/Assistant';
import { usePractice } from '../../../context/PracticeContext';
import { useRoot } from '../../../context/RootContext';
import DescriptiveAnswer from './DescriptiveAnswer';
import { getIsDescAnsQues } from '../../../utils/TutorConstants';
import { useTutor } from '../../../context/AiTutorContext';

export default function Comprehensive(props) {
    const { displaySubmit, isAnswerSubmitted, isDiscussFlow } = props;
    const { setDisplayedQues, currentQuesIndex, handleExtraAndStoreImages, setIsDescAnsQues, isDescAnsQues } = usePractice();
    const { setRubricInfo } = useRoot();
    const { comprehensionForSME } = useTutor()
    const { mainQuestion, subQuestionsList } = comprehensionForSME || {};

    useEffect(() => {
        const shouldProcessQuestion = subQuestionsList?.length > 0 &&
            currentQuesIndex != -1 && currentQuesIndex != subQuestionsList?.length;
        if (shouldProcessQuestion) {
            const quesObj = subQuestionsList?.[currentQuesIndex];
            const { rubric = {} } = quesObj;
            setDisplayedQues((prev) => [...prev, quesObj]);
            handleExtraAndStoreImages(quesObj, 0);
            setIsDescAnsQues(getIsDescAnsQues(quesObj));
            const { _id, rubricId, rubricType, name: rubricName } = rubric;
            setRubricInfo({
                rubricID: rubricId || _id,
                rubricName: rubricName,
                rubricType: rubricType,
                subjectID: quesObj?.subjects?.[0],
                topicDetails: quesObj?.syllabusMapping?.[0],
            });
        }
    }, [subQuestionsList, currentQuesIndex])
    return (
        <Box>
            <Assistant
                text={mainQuestion?.question_layout}
                hideVin={true}
                isCopy={false}
                isQuestion={false}
                isComprehension={true}
                audioPlayer={undefined}
            />
            <PracticeLayout
                displaySubmit={displaySubmit}
                isAnswerSubmitted={isAnswerSubmitted}
                isDiscussFlow={isDiscussFlow}
            />
            {isDescAnsQues &&
                <Box marginTop={"-36px"}>
                    <DescriptiveAnswer />
                </Box>
            }
        </Box>
    )
}
